import React from 'react';
import Icon from '@ant-design/icons';
import { Alert, ConfigProvider } from 'antd';
import { ReactComponent as InfoSvg } from '../../assets/icons/info-alert.svg';

import './AlertFieldsMandatory.css';
import { useTheme } from '../../context/ThemeContext';
import { DARK } from '../../utilities/constants';

const AlertFieldsMandatory = () => {
  const { theme } = useTheme();
  return (
    <ConfigProvider
      theme={{
        components: {
          Alert: {
            colorInfoBg: theme === DARK ? '#9DC9FF' : '#D1E4FF',
            defaultPadding: '4px 12px',
            fontSize: 14,
            colorText: '#000000',
          },
        },
      }}
    >
      <Alert
        message="All fields are mandatory unless mentioned otherwise."
        banner
        type="info"
        icon={<Icon style={{ fontSize: '18px' }} component={InfoSvg} />}
        className="alert-mandatory-fields"
      />
    </ConfigProvider>
  );
};

export default AlertFieldsMandatory;
